var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.51562V10.5C0 11.3438 2.01562 12 4.5 12C6.98438 12 9 11.3438 9 10.5V9.51562C8.01562 10.1953 6.25781 10.5 4.5 10.5C2.71875 10.5 0.960938 10.1953 0 9.51562ZM7.5 3C9.98438 3 12 2.34375 12 1.5C12 0.679688 9.98438 0 7.5 0C5.01562 0 3 0.679688 3 1.5C3 2.34375 5.01562 3 7.5 3ZM0 7.05469V8.25C0 9.09375 2.01562 9.75 4.5 9.75C6.98438 9.75 9 9.09375 9 8.25V7.05469C8.01562 7.85156 6.25781 8.25 4.5 8.25C2.71875 8.25 0.960938 7.85156 0 7.05469ZM9.75 7.3125C11.0859 7.05469 12 6.5625 12 6V5.01562C11.4375 5.39062 10.6406 5.64844 9.75 5.8125V7.3125ZM4.5 3.75C2.01562 3.75 0 4.59375 0 5.625C0 6.67969 2.01562 7.5 4.5 7.5C6.98438 7.5 9 6.67969 9 5.625C9 4.59375 6.98438 3.75 4.5 3.75ZM9.63281 5.08594C11.0391 4.82812 12 4.33594 12 3.75V2.76562C11.1562 3.35156 9.72656 3.65625 8.22656 3.75C8.90625 4.07812 9.42188 4.52344 9.63281 5.08594Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.634d99a11144a979f4f000749ad0bc03.svg";
export { ForwardRef as ReactComponent };